import * as React from 'react'
import { useBulkActionLabels } from './useBulkActionLabels'
import {
  BulkActionsFooter,
  BulkActionsLabel,
  BulkActionsProps,
  SelectedRowCount,
} from '@user/components/xGrid'

export const DraftLeadBulkActionFooter: React.FC<BulkActionsProps> = ({
  selectedRows,
}) => {
  const { avgAge } = useBulkActionLabels(selectedRows)

  return (
    <BulkActionsFooter>
      <SelectedRowCount count={selectedRows.size} />
      <BulkActionsLabel label={avgAge} />
    </BulkActionsFooter>
  )
}
DraftLeadBulkActionFooter.displayName = 'DraftLeadBulkActionFooter'
